export const heatmapRadius = 40;
export const heatmapIntensity = 20;
